import { render, staticRenderFns } from "./EmployerMatchEOYRequirementRadio.vue?vue&type=template&id=36524c4c&"
import script from "./EmployerMatchEOYRequirementRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchEOYRequirementRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports